module.exports = __webpack_public_path__ + "img/TMINC_Clear_Logo.a9d5e376.png";